import { ArrowRight, Building2 } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/lib/api";
import { PHOTO } from "@/lib/assets";

const FLEET_SERVICES = [
  "Acquisition",
  "Remplacement",
  "Vente",
  "Entretien",
  "Coordination mécanique",
  "Suivi des véhicules",
  "Recherche de véhicules",
  "Gestion des renouvellements",
];

export default function Fleet() {
  return (
    <section id="flotte" data-testid="fleet-section" className="py-24 md:py-32 lg:py-36">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-4 border border-white/10 rounded-2xl -translate-x-4 translate-y-4" />
              <div className="relative rounded-2xl overflow-hidden border border-white/10">
                <img
                  src={PHOTO.fleet}
                  alt="Véhicules de prestige alignés devant un édifice moderne — gestion de parc automobile"
                  className="w-full h-[340px] sm:h-[420px] object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" />
                <div className="absolute bottom-5 left-5 flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-slate-300">
                  <Building2 size={13} className="text-gold" /> Division entreprises
                </div>
              </div>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-6 order-1 lg:order-2">
          <Reveal>
            <span className="overline-tag">Pour les entreprises</span>
            <h2 className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.1] tracking-tight">
              Gestion automobile
              <br />
              <span className="gold-text">pour entreprises.</span>
            </h2>
            <p className="mt-7 text-sm sm:text-base text-slate-300 font-light leading-relaxed max-w-xl">
              Que vous possédiez un seul véhicule d'entreprise ou plusieurs véhicules, Gestion Automobile
              Exécutive peut vous accompagner dans la gestion et le renouvellement de votre parc automobile.
            </p>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="mt-8 flex flex-wrap gap-2.5" data-testid="fleet-services-list">
              {FLEET_SERVICES.map((s) => (
                <span
                  key={s}
                  className="text-xs text-slate-200 border border-white/15 bg-white/[0.03] rounded-full px-4 py-2 hover:border-gold/50 hover:text-gold-light transition-colors duration-300"
                >
                  {s}
                </span>
              ))}
            </div>
            <button data-testid="fleet-cta-talk" onClick={() => scrollToId("#contact")} className="btn-outline mt-10">
              Parler de ma flotte <ArrowRight size={15} />
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
